import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { Application } from "./App";

ReactDOM.render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>,
  document.getElementById("root")
);

require("dotenv").config({ path: "../.env" });
